import { useQuery } from '@apollo/client';
import { notEmpty } from '@crehana/utils';

import GET_CHECKOUT_COUNTRIES_OPTIONS from '../graphql/GetCheckoutCountriesOptions.graphql';
import type { GetCheckoutCountriesOptions } from '../graphql/types/GetCheckoutCountriesOptions';

const useCheckoutCountriesOptions = () => {
  const { data, loading, error } = useQuery<GetCheckoutCountriesOptions>(
    GET_CHECKOUT_COUNTRIES_OPTIONS,
  );

  const countries =
    data?.countries?.edges.filter(notEmpty).map(el => ({
      value: el.node?.value || '',
      label: el.node?.label || '',
      id: el.node?.originalId || 0,
    })) || [];

  return { countries, loading, error };
};

export default useCheckoutCountriesOptions;
